/* Copyright 2015 Bloomberg Finance L.P.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { DOMWidgetModel } from '@jupyter-widgets/base';
import { semver_range } from './version';
export class TooltipModel extends DOMWidgetModel {
    defaults() {
        return Object.assign(Object.assign({}, DOMWidgetModel.prototype.defaults()), { _model_name: 'TooltipModel', _view_name: 'Tooltip', _model_module: 'bqplot', _view_module: 'bqplot', _model_module_version: semver_range, _view_module_version: semver_range, fields: [], formats: [], show_labels: true, labels: [] });
    }
}
//# sourceMappingURL=TooltipModel.js.map